
import { useState } from "react";
import { Search } from "../../../../assets/icons";
import InputWithIcon from "../../../common/input/InputWithIcon";

export default function SearchSection({ initQuery, onSearch }) {
	const [query, setQuery] = useState(initQuery);

	function handleKeyPress(e) {
		if (e.key === "Enter") {
			onSearch(query);
		}
	}

	return (
		<div className="relative w-full overflow-hidden rounded-[16px] border border-darkBlue/10 bg-white p-5 shadow-[0_8px_24px_rgba(39,106,166,0.08)]">
			<div
				className="pointer-events-none absolute inset-x-0 top-0 h-[3px] bg-gradient-to-l from-cta via-[#FF8A6B] to-darkBlue"
				aria-hidden
			/>
			<div className="font-Vazir-600 text-[17px] text-darkBlue text-center">
				جستجو در درمانگران
			</div>
			<p className="mt-1 text-center font-Vazir-400 text-[13px] text-darkBlue/55">
				نام یا معرفی کوتاه درمانگر را جستجو کنید
			</p>
			<div className="lg:w-[330px] flex flex-col justify-center items-center align-middle mx-auto">
				<InputWithIcon
					onChange={(e) => setQuery(e.target.value)}
					onKeyPress={handleKeyPress}
					width="330px"
					marginBlock="10px"
					iconColor="#FF6A4B"
					icon={<Search />}
					placeholder="نام درمانگر"
				/>
			</div>
		</div>
	)
}
